var YouTubeService = function() {};
YouTubeService.prototype = _.extend({
  initVideo: function(videoId, options, callbacks) {
    this.callbacks = callbacks;
    this.state = 'IDLE';
    var self = this;
    let matches = videoId.match(/(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:.*)/);
    if(matches) {
      videoId = matches[1];
    }

    var loadVideo = function() {
      var videoPlayer = new window.YT.Player(options.container, {
        height: options.height || '390',
        width: options.width || '640',
        videoId: videoId,
        playerVars: {
          //"autoplay": 1,
          'modestbranding': 1,
          'rel': 0,
          'showinfo': 0,
          'iv': 3,
          'theme': 'light',
          'enablejsapi': 1
        },
        events: {
          'onReady': _.bind(self.onPlayerReady, self),
          'onStateChange': _.bind(self.onStateChange, self)
        }
      });
    };

    if(window.YT && window.YT.Player) {
      loadVideo();
    } else {
      this.script = $('<script id="youTubeApi" src="https://www.youtube.com/iframe_api?origin=*"></script>');
      $('head').append(this.script);
      window.onYouTubeIframeAPIReady = loadVideo;
    }

  },
  onPlayerReady: function(event) {
    this.videoPlayer = event.target;
    if(this.playWhenReady) {
      this.videoPlayer.playVideo();
    }
    this.trigger('ready');
    if(EF.enrollment.getData('muted') === 'on') {
      this.mute();
    }

    function updateTime() {
      if(this.videoPlayer && this.videoPlayer.getCurrentTime) {
        this.duration = this.duration || this.videoPlayer.getDuration();

        var newTime = this.videoPlayer.getCurrentTime();
        if(newTime !== this.position) {
          this.position = newTime;
          this.trigger('time', {
            duration: this.duration,
            position: this.position
          });
        }

        var newVolume = this.videoPlayer.isMuted() ? 0 : this.videoPlayer.getVolume();
        if(newVolume != this.volume) {
          this.volume = newVolume;
          Chaplin.mediator.publish('media:mute:change', this.volume === 0 ? 'on' : 'off');
        }
      }
    }
    this.timeInterval = setInterval(_.bind(updateTime, this), 100);
  },
  onStateChange: function(event) {
    switch(event.data) {
      case YT.PlayerState.ENDED:
      case YT.PlayerState.CUED:
        this.state = 'IDLE';
        break;
      case YT.PlayerState.PAUSED:
        this.state = 'PAUSED';
        break;
      case YT.PlayerState.PLAYING:
        this.state = 'PLAYING';
        break;
      case YT.PlayerState.BUFFERING:
        this.state = 'BUFFERING';
        break;
      default:
        this.state = 'IDLE';
    }

    if(event.data == YT.PlayerState.ENDED) {
      if(this.callbacks.end) {
        this.callbacks.end();
      }
    }
    if(event.data == YT.PlayerState.PLAYING) {
      if(this.callbacks.play) {
        this.callbacks.play();
      }
    }
    if(event.data == YT.PlayerState.PAUSED) {
      if(this.callbacks.pause) {
        this.callbacks.pause();
      }
    }
  },
  play: function() {
    if(this.videoPlayer) {
      this.videoPlayer.playVideo();
    } else {
      this.playWhenReady = true;
    }
  },
  pause: function() {
    this.videoPlayer.pauseVideo();
  },
  stop: function() {
    if(this.videoPlayer) {
      this.videoPlayer.stopVideo();
    }
  },
  mute: function() {
    if(this.videoPlayer !== null) {
      this.videoPlayer.mute();
    }
  },
  unmute: function() {
    if(this.videoPlayer !== null) {
      this.videoPlayer.unMute();
    }
  },
  getState: function() {
    if(this.videoPlayer !== null) {
      return this.state;
    }
  },
  getMute: function() {
    if(this.videoPlayer !== null) {
      return this.videoPlayer.isMuted();
    }
  },
  setMute: function(mute) {
    if(this.videoPlayer !== null) {
      if(mute) {
        this.videoPlayer.mute();
      }
      else {
        this.videoPlayer.unMute();
      }
    }
  },
  dispose: function() {
    this.playWhenReady = false;
    this.videoPlayer = null;
    clearInterval(this.timeInterval);
  }
}, Backbone.Events);

module.exports = YouTubeService;
